/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React from 'react';
import cx from 'classnames';
import Checkbox from '@mui/material/Checkbox';
import { Link, useNavigate } from 'react-router-dom';

import LockImg from '@assets/lock_terms.png';

import useConnectionContext, { ConnectionProvider } from '../../../hooks/useConnectionContext';
import ConnectionCard, { ConnectionCardSkeleton } from '../../Home/ConnectionCard';
import { usePaymentConnection } from '../../Home/Connection';

import classes from './index.module.css';
import request from '../../../api';

const Payment = () => {
  const { payment, isLoading } = useConnectionContext();
  const { openPlaidLink } = usePaymentConnection();
  const { connected } = payment || {};
  return (
    <div className={classes.payment}>
      <div className={classes.payment_title}>Payment information</div>
      <div style={{ width: 20, height: 20 }} />
      <div className={classes.payment_desc}>
        This will be used for any plan payments and to collect the Guaranteed Delivery Date insurance premiums.
      </div>
      <div style={{ width: 20, height: 20 }} />
      <div className={classes.payment_desc}>
        <span className={classes.payment_desc_imp}>NOTE: Guaranteed Delivery Date is free to you (If you offer free shipping discount, the premium will still be charged). </span>
        But we still need your payment information.
        Here’s why: Your customer pays Seel’s insurance premium to you with their order payment, and Seel needs a way to collect that payment from you.
      </div>
      <div style={{ width: 20, height: 20 }} />
      {
        isLoading ? <ConnectionCardSkeleton cxname={classes.payment_skeleton} /> : (
          connected ? (
            <>
              <div className={cx([classes.payment_desc_imp], [classes.payment_desc])}>*If you offer free shipping discount, the premium will still be charged.</div>
              <div style={{ width: 20, height: 20 }} />
              <ConnectionCard css={{ width: 600 }} isLoading={isLoading} data={{ ...payment, title: 'your Bank account' }} />
            </>
          )
            : (
              <div
                onKeyUp={() => undefined}
                role="button"
                tabIndex="0"
                onClick={openPlaidLink}
                className={classes.button}
              >
                Connect bank account
              </div>
            )
        )
      }
    </div>
  );
};

const Terms = () => {
  const { payment: { connected }, isLoading, merchantId } = useConnectionContext();
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);
  // const [checked, setChecked] = React.useState(false);

  const handleChange = () => {
    setChecked(!checked);
  };
  const handleClick = async () => {
    try {
      const { code, data, message } = await request('enable-gdd', {
        method: 'POST',
        body: {
          merchantId,
          openGdd: true,
        },
      });
      if (code === 0) {
        navigate('/');
      }
      console.log({ code, data, message });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div className={classes.terms}>
      { (isLoading || !connected) ? <div className={classes.lock}>{connected === false ? <img src={LockImg} className={classes.lock_img} alt="" /> : null}</div> : null}
      <div className={classes.terms_line}>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          sx={{
            '&.MuiButtonBase-root': {
              marginLeft: '-11px',
            },
            '&.Mui-checked': {
              color: '#645AFF',
            },
          }}
        />
        <div className={classes.terms_line_text}>
          I have read and agreed to
          {' '}
          <Link to="https://www.seel.com/terms/seel-guaranteed-delivery-date-terms-of-service" className={classes.terms_line_hightlight}>Terms and Conditions</Link>
        </div>
      </div>
      <div
        onClick={handleClick}
        onKeyUp={handleClick}
        role="button"
        tabIndex="0"
        className={
          cx({ [classes.button]: true, [classes.button_disable]: !checked })
        }
      >
        Enable Now
      </div>
    </div>
  );
};

export default function Review() {
  return (
    <ConnectionProvider>
      <div>
        <div className={classes.header}>Upgrade to guaranteed delivery date</div>
        <Payment />
        <Terms />
      </div>
    </ConnectionProvider>
  );
}
